// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0f63ea3a","126":"ca5e541f","171":"e2e17f14","220":"bfda26ae","842":"fcf52901","940":"472fcdd9","998":"8612b673"}[chunkId] + ".chunk.js";
};